
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppImageHolder, AppFileUpload, AppSelect, AppCard, AppButton } from '@/components';
import { useAvatarGender } from '@/modules/avatar/gender/model/gender';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.GENDER,
    components: { AppFormRow, AppImageHolder, AppFileUpload, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions, AvatarGender } = useAvatarGender();

        onMounted(() => {
            fetch();
        });

        return { v$, model, fetch, actions, AvatarGender };
    }
});
